export default __webpack_public_path__ + "static/media/bank-ubs.bf0f8f80.svg";